<template>
  <div class="relative-article">
    <div class="box box-align-center ra-top">
      <div class="rat-txt">添加班级：</div>
      <el-button type="primary" plain icon="el-icon-plus" @click="() => (chooseVisible = true)"> 选班级
      </el-button>
    </div>
    <div class="ra-table">
      <dy-table :columns="columns" :table-data="tableData" :isShowPager="false"></dy-table>
    </div>
    <el-dialog v-if="chooseVisible" title="选班级" :visible.sync="chooseVisible" append-to-body width="60%"
      :close-on-click-modal="false">
      <classSelect :columns="_columns" @close-dialog="() => (chooseVisible = false)" @saveData="saveData"
        :list="this.tableData">
      </classSelect>
    </el-dialog>
  </div>
</template>
<script>
import DyTable from '@/components/common/dytable';
import classSelect from './classSelect';
export default {
  components: {
    DyTable,
    classSelect,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    list(newVal, oldVal) {
      this.tableData = newVal;
    },
    // tableData(newArr, oldArr) {
    //     this.$emit('save-data', this.tableData);
    // }
  },
  data() {
    return {
      tableLoading: true,
      columns: [],
      _columns: [],
      tableData: [],

      chooseVisible: false,
    };
  },
  created() {
    let col = [
      {
        key: 'className',
        title: '班级名称',
      },
      {
        key: 'classNumber',
        title: '班群号',
      },
      {
        key: 'idName',
        title: '班主任',
      },

    ];

    this.columns = [
      {
        type: 'index',
      },
      ...col,
      {
        key: 'updateTime',
        title: '最后更新时间',
      },
      {
        key: '',
        title: '操作',
        render: ({ row }) => {
          return (
            <div onClick={() => this.delItem(row)}>
              <el-link type='danger'>删除</el-link>
            </div>
          );
        },
      },
    ];
    this._columns = col;
  },
  mounted() {
    this.tableData = this.list;
  },
  methods: {
    //删除数据
    delItem(row) {
      let index = this.tableData.findIndex((item) => item.id == row.id);
      this.tableData.splice(index, 1);
      this.saveData();
    },

    saveData(arr) {
      this.tableData = arr || this.tableData;
      this.$emit('saveData', {
        data: this.tableData,
      });
    },
  },
};
</script>
<style scoped>
.ra-table {
  margin-top: 12px;
  margin-bottom: 22px;
}
</style>
